import { Pipe, PipeTransform } from '@angular/core';

/**
 * a handy number pipe to insert commas.
 */
@Pipe({
  name: 'thousands'
})
export class ThousandsPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const nfObject = new Intl.NumberFormat('en-US');
    return nfObject.format(parseFloat(value));
  }

}
